import {html, svg} from '@isceco/widget-library2/external/lit'
import KarteRender from './KarteRender.js'
import Schweizerkarte from './Schweizerkarte.js'
import i18n from './i18n.json'
import '../GasPopup/GasPopup.js'

export class SchweizerkarteGas extends Schweizerkarte {
  get popups() {
    return {
      'rc-basel': {
        code: 'RCB',
        left: true,
        x: 551,
        y: 380,
        r: 15
      },
      'oltingue': {
        code: 'OLT',
        left: true,
        x: 470,
        y: 440,
        template: this._popupCHTransit,
        open: true
      },
      'altavila': {
        code: 'ALTA',
        left: true,
        x: 442,
        y: 585,
        template: this._popupOW
      },
      'schonenbuch': {
        code: 'SCHOE',
        left: true,
        x: 490,
        y: 395
      },
      'la-cure': {
        code: 'LAC',
        left: true,
        x: 240,
        y: 702,
        open: true
      },
      'savoie': {
        code: 'SAV',
        left: true,
        x: 310,
        y: 790,
        r: 40
      },
      'rc-fallentor': {
        code: 'RCF',
        x: 752,
        y: 350
      },
      'hochst': {
        code: 'HOE',
        x: 890,
        y: 421
      },
      'wallbach': {
        code: 'WB',
        x: 572,
        y: 392,
        r: 15,
        template: this._popupCHTransit,
        open: true
      },
      'griespass': {
        code: 'GRIE',
        x: 647,
        y: 770,
        template: this._popupCHTransit,
        open: true
      },
      'bizzarone': {
        code: 'GEBI',
        x: 752,
        y: 880,
        open: true
      }
    }
  }

  firstUpdated(changedProperties) {
    this.updateComplete.then(_ => {
      Object.values(this.popups)
        .forEach(p => {
          const popup = this._getPopup(p.code)
          const hover = this._getHover(p.code)
          if (p.open) {
            popup.position(hover)
          } else {
            popup.toggle(hover)
          }
        })
    })
  }

  render() {
    return html`
      <style>@import '${iscecoWidgetLibrary.iconCss}';</style>
      <div class="inline">
        <div class="left">
          ${Object.values(this.popups).filter(p => p.left).map(this._popup)}
        </div>
        <div class="map">
          ${KarteRender(this.renderGasfluesse())}
        </div>
        <div class="right">
          ${Object.values(this.popups).filter(p => !p.left).map(this._popup)}
        </div>
      </div>
    `
  }

  renderGasfluesse() {
    return svg`
      <!--Pfeile-->
      ${this.renderPfeile()}

      <!--Hover Zonen-->
      <g id="verbindungspunkte" fill="rgba(0, 0, 0, 0)" stroke="none">
        ${Object.values(this.popups).map(this._hoverZone)}
      </g>
    `
  }

  _hoverZone = ({code, x, y, r = 25}) => {
    return svg`
      <circle id="hover-${code}" cx="${x}" cy="${y}" r="${r}"
              style="cursor: pointer"
              @mouseenter="${e => this._showPopup(code, e)}"
              @mouseleave="${_ => this._hidePopup(code)}"
              @click="${e => this._togglePopup(code, e)}"
      />
    `
  }

  _popupCH = code => {
    const ch = this.dataMap[code]
    return html`
      <h2>${translateText(i18n, 'einspeisepunkt')} ${ch.name}</h2>
      <div class="section">
        <p>${translateText(i18n, 'technisch.ch')}: ${ch.technisch}</p>
        <p>${translateText(i18n, 'gebucht.ch')}: ${ch.gebucht}</p>
        <p>${translateText(i18n, 'nominiert.ch')}: ${ch.nominiert}</p>
        ${this._effektiv(ch.effektiv)}
        <p>${translateText(i18n, 'auslastung.ch')}: ${ch.auslastung} % (${translateText(i18n, 'nominiert.gebucht')})</p>
        ${this._bemerkung(ch.bemerkung)}
      </div>
    `
  }

  _popupCHTransit = code => {
    const ch = this.dataMap[`${code}CH`]
    const transit = this.dataMap[`${code}T`]
    return html`
      <h2>${translateText(i18n, 'einspeisepunkt')} ${translateText(i18n, code)}</h2>
      <div class="section">
        <p>${translateText(i18n, 'technisch.ch')}: ${ch.technisch}</p>
        <p>${translateText(i18n, 'gebucht.ch')}: ${ch.gebucht}</p>
        <p>${translateText(i18n, 'nominiert.ch')}: ${ch.nominiert}</p>
        ${this._effektiv(ch.effektiv)}
        <p>${translateText(i18n, 'auslastung.ch')}: ${ch.auslastung} % (${translateText(i18n, 'nominiert.gebucht')})</p>
        ${this._bemerkung(ch.bemerkung)}
        <p>${translateText(i18n, 'technisch.transit')}: ${transit.technisch}</p>
        <p>${translateText(i18n, 'nominiert.transit')}: ${transit.nominiert}</p>
        ${this._bemerkung(transit.bemerkung)}
      </div>
    `
  }

  _popupOW = code => {
    const ow = this.dataMap[`${code}OW`]
    const wo = this.dataMap[`${code}WO`]
    return html`
      <h2>${translateText(i18n, 'verbindung')} ${translateText(i18n, code)}</h2>
      <div class="section">
        <p>${translateText(i18n, 'technisch.west.ost')}: ${wo.technisch}</p>
        ${this._bemerkung(wo.bemerkung)}
        <p>${translateText(i18n, 'technisch.ost.west')}: ${ow.technisch}</p>
        ${this._bemerkung(ow.bemerkung)}
      </div>
    `
  }

  _bemerkung = text => text ? html`<p class="bemerkung"><i class="icon info circle"></i>${text}</p>` : ''

  _effektiv = effektiv => effektiv === 'na' ? '' : html`<p>${translateText(i18n, 'effektiv')}: ${effektiv}</p>`

  _popup = ({code, template = this._popupCH, left = false}) => {
    const content = template(code)
    return html`
      <gasmonitoring-popup id="popup-${code}" ?left="${!left}"">
        ${content}
      </gasmonitoring-popup>
    `
  }
}

customElements.define('gasmonitoring-schweizerkarte-gas', SchweizerkarteGas)
